import React, { useEffect, useState, useMemo } from 'react';
import './Bracket.css';
import { SERVICE_URL } from "../config";
import axios from "axios";
import { useParams } from 'react-router-dom';
import {
  SingleEliminationBracket,
  SVGViewer,
  Match,
    createTheme
} from '@g-loot/react-tournament-brackets';
import ClickableMatch from '@components/ClickableMatch';

const MyBracketAditional = () => {
  const [matches, setMatches] = useState([
]);

    const { championshipcode, championshipname } = useParams();

  const STAGE_LABELS = {
  19: '16avos de final',
  18: '8vos de final',
  20: '4tos de final',
  21: 'Semi Finales',
  22: 'Final',
  24: 'Tercer Puesto',
};

function transformToBracketStructure(originalData) {
  // Primero, creamos un mapa para encontrar bracketmatchcode por gamecode
  const gamecodeToBracketmatchcode = new Map();
  originalData.forEach(match => {
    gamecodeToBracketmatchcode.set(match.game.gamecode, match.bracketmatchcode);
  });

  // Mapa para los partidos transformados
  const matchesMap = new Map();
  
  // Procesamos cada partido del arreglo original
  originalData.forEach(match => {
    // Determinamos el nextMatchId buscando el bracketmatchcode del partido padre
    let nextMatchId = null;
    if (match.parentmatchcode !== null) {
      nextMatchId = gamecodeToBracketmatchcode.get(match.parentmatchcode) || null;
    }

    // Creamos el objeto de partido en el nuevo formato
    const newMatch = {
      id: match.bracketmatchcode,
      gamecode: match.game.gamecode,
      gamestatuscode : match.game.gamestatuscode,
      name: `${match.game.teamlocal.teamname} vs ${match.game.teamvisitor.teamname}`,
      nextMatchId: nextMatchId,
      tournamentRoundText: getRoundText(match.stagecode),
      startTime: '',
      state:  match.game.gamestatuscode ==2 ? '"SCORE_DONE"' : '', // Estado inicial
      participants: [
        {
          id: match.game.teamlocal.teamcode.toString(),
          name: match.game.teamlocal.teamname,
          isWinner: match.winnerteamcode == match.game.teamlocal?.teamcode,
          resultText : match.game.goallocal.toString(),
          image: match.game.teamlocal.image,
          state:  'PLAYED', // Estado inicial
        },
        {
          id: match.game.teamvisitor.teamcode.toString(),
          name: match.game.teamvisitor.teamname,
          resultText: match.game.goalvisitor.toString(), // Agrega esto
          isWinner: match.winnerteamcode == match.game.teamvisitor?.teamcode,
          state: 'PLAYED', // Estado inicial
        }
      ]
    };
    matchesMap.set(match.bracketmatchcode, newMatch);
  });
  
  // Convertimos el mapa a un arreglo
  return Array.from(matchesMap.values());
}
// Función auxiliar para determinar el texto de la ronda basado en stagecode
function getRoundText(stagecode) {
  switch(stagecode) {
    case 18: return 'Octavos de final';
    case 19: return '16avos de final';
    case 20: return 'Cuatos de Final';
    case 21: return 'Final';
    case 22: return 'Campeón';
    case 24: return 'Tercer lugar';
    default: return `Ronda ${stagecode}`;
  }
}

useEffect(() => {
  axios.post(`${SERVICE_URL}game/bracket`, { championshipcode })
    .then(res => {
      if (res.data.success) {
 const formated = transformToBracketStructure(res.data.data);
        setMatches(formated);
      }
    })
    .catch(console.error);
}, [championshipcode]);


const GlootTheme = createTheme({
  textColor: {
    main: "#585954",              // --text-light
    highlighted: "#FDCA40",       // --accent
    dark: "#8EA2AB",              // --text-dark
  },
  matchBackground: {
    wonColor: "#000",          // --green
    lostColor: "#111312",         // --widget-dark
  },
  score: {
    background: {
      wonColor: "#000",           // --body-dark
      lostColor: "#111312",       // --widget-dark
    },
    text: {
      highlightedWonColor: "#04E762",   // --neon-green
      highlightedLostColor: "#ED0423",  // --red
    },
  },
  border: {
    color: "#E0E5D5",             // --border-light
    highlightedColor: "#FDCA40",  // --accent
  },
  roundHeader: {
    backgroundColor: "#292B23",   // --header-light
    fontColor: "#fff",            // --header-dark
  },
  connectorColor: "#A2C0D4",      // --nav-arrow
  connectorColorHighlight: "#FDCA40", // --accent
  svgBackground: "#FAFAF8",       // --body-light
});


return (
       <>
       <br />
           <div className="d-flex justify-content-between align-items-center">
              <h3>Cuadro Final - {championshipname}</h3>
            </div>

<div className="bracket-container">
  <div className="bracket-wrapper">
    {matches.length > 0 ? (
      <SingleEliminationBracket
        theme={GlootTheme}
        matches={matches}
        matchComponent={ClickableMatch}
        SVGWrapper={({ children, ...props }) => (
          <SVGViewer width="100%" height="100%" {...props}>
            {children}
          </SVGViewer>
        )}
      />
    ) : (
      <p style={{ textAlign: 'center' }}>Cargando partidos...</p>
    )}
  </div>
</div>
       </>
 
      

);
};

export default MyBracketAditional;